import { useHistory } from "react-router-dom";
import { type Cluster } from "@doitintl/cmp-models";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Box, IconButton, Stack, Typography } from "@mui/material";

import { useCustomerContext } from "../../../../Context/CustomerContext";
import PercentileSelector, { type Percentile } from "./Components/PercentileSelector";
import TimeRangeSelector, { type TimeRange } from "./Components/TimeRangeSelector";

interface ClusterDetailHeaderProps {
  cluster: Cluster | undefined;
  percentile: Percentile;
  timeRange: TimeRange;
  onChangePercentile: (percentile: Percentile) => void;
  onChangeTimeRange: (timeRange: TimeRange) => void;
  loading?: boolean;
  clusterHasAgent?: boolean;
}

const ClusterDetailHeader = ({
  cluster,
  onChangePercentile,
  onChangeTimeRange,
  percentile,
  timeRange,
  loading,
  clusterHasAgent = false,
}: ClusterDetailHeaderProps) => {
  const history = useHistory();
  const { customer } = useCustomerContext();

  const goBack = () => {
    history.push(`/customers/${customer.id}/dashboards/Kubernetes Lens`);
  };

  return (
    <Box
      justifyContent="space-between"
      display="flex"
      alignItems={{ xs: "flex-start", sm: "center" }}
      flexDirection={{ xs: "column", sm: "row" }}
    >
      <Stack direction="row" alignItems="center" spacing={1} mb={{ xs: 2, sm: 0 }}>
        <IconButton onClick={goBack}>
          <ArrowBackIcon />
        </IconButton>
        <Typography variant="h1">{cluster?.name}</Typography>
      </Stack>
      {clusterHasAgent && (
        <Stack direction="row" spacing={1} alignSelf="flex-end">
          <PercentileSelector value={percentile} onChange={onChangePercentile} disabled={loading} />
          <TimeRangeSelector value={timeRange} onChange={onChangeTimeRange} disabled={loading} />
        </Stack>
      )}
    </Box>
  );
};

export default ClusterDetailHeader;
